'use client';
import { hideModal } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { Button, Stack } from '@mui/material';
import { repaymentTerms } from '@repo/onb-api';
import { PaymentSchedule } from '@repo/ui';
import { formatter } from '@repo/utils';
import { useDispatch, useSelector } from 'react-redux';

// Due dates come as yyyy-MM-dd; compare as strings against the local day so the timezone can't shift "Hoy"
const todayKey = () => {
  const now = new Date();
  return `${now.getFullYear()}-${`${now.getMonth() + 1}`.padStart(2, '0')}-${`${now.getDate()}`.padStart(2, '0')}`;
};

/**
 * Renders the selected plan's payment schedule for a Modal component: a summary strip, then every installment
 * as a numbered row with its due date and amount.
 *
 * @return {React.JSX.Element} The rendered SelectedPlanBody component.
 */
export const SelectedPlanBody = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const { steps } = useSelector((state: RootState) => state.flowdata);
  const stepData = steps.find(({ name }) => name === 'REPAYMENT_TERMS') as repaymentTerms;
  const plan = stepData.variables.installments?.find(({ planId }) => planId === stepData?.variables?.installmentPlanId);
  const schedule = plan?.paymentSchedule || [];
  const total = plan?.finalAmount ?? schedule.reduce((sum, { amount }) => sum + amount, 0);
  const today = todayKey();

  return (
    <Stack sx={{ gap: 3, width: '100%' }}>
      <PaymentSchedule
        count={plan?.count}
        installmentAmount={plan?.amount}
        total={total}
        withInterest={plan?.withInterest}
        items={schedule.map(({ dueDate, number, amount }) => {
          const isToday = dueDate <= today;
          return {
            number,
            amount,
            highlight: isToday,
            dueLabel: isToday ? 'Vence hoy' : `Vence el ${formatter(dueDate, 'date')}`,
          };
        })}
      />
      <Button
        onClick={(e) => {
          e.preventDefault();
          dispatch(hideModal());
        }}
        fullWidth
      >
        Entendido
      </Button>
    </Stack>
  );
};
